<template>
  <q-dialog title="编辑订单" :visible="isVisible" width="500px" :innerScroll="false" @close="handleClose" @cancel="handleClose">
    <el-form :model="editForm" label-width="100px">
      <el-form-item label="平台单号：">
        <span v-for="(item, index) in selectSpus" :key="index">{{ item.orderNo + "， " }}</span>
      </el-form-item>
      <el-form-item label="标签：" class="input">
        <el-select v-model="editForm.orderTag">
          <el-option label="正常" value="正常"></el-option>
          <el-option label="删除" value="删除"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确认</el-button>
    </template>
  </q-dialog>
</template>

<script>
export default {
  name: "EditDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    selectSpus: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  data() {
    return {
      editForm: {
        orderTag: "",
      },
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.editForm = { orderTag: "" };
      }
    },
  },
  methods: {
    handleClose() {
      this.isVisible = false;
    },
    handleConfirm() {
      let arr = [];
      this.selectSpus.forEach((v) => {
        arr.push({
          orderNo: v.orderNo,
          orderTag: this.editForm.orderTag,
        });
      });
      this.$q.dataImport
        .UpdaUnsaleOrder({
          data: JSON.stringify(arr),
        })
        .then((data) => {
          if (data.code === "200") {
            this.$message.success("编辑成功");
            this.$emit("success");
            this.handleClose();
          } else {
            this.$message.error(data.message);
          }
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .input .el-input__inner
  width 150px
  height 28px
</style>
